import { defineSlotRecipe } from '@chakra-ui/react';
import { checkboxAnatomy } from '@chakra-ui/react/anatomy';
const interactiveCursor = {
    cursor: 'pointer',
    _disabled: { cursor: 'not-allowed' },
};
export const checkboxRecipe = defineSlotRecipe({
    slots: checkboxAnatomy.keys(),
    base: {
        root: interactiveCursor,
        control: interactiveCursor,
        label: interactiveCursor,
    },
});
